<template>
	<Modal
		:visible="visible"
		:title="$t('account.externalApiKeys.createdModal.header')"
		:footer="null"
		@cancel="$emit('close')"
	>
		<TypographyParagraph>{{ $t('account.externalApiKeys.createdModal.description') }}</TypographyParagraph>
		<Input :value="rawKey" readonly />
		<Space class="pd-vertical">
			<Button type="primary" @click="copyRawKey">{{ $t('account.externalApiKeys.createdModal.copyButtonLabel') }}</Button>
			<Button @click="$emit('close')">{{ $t('account.externalApiKeys.createdModal.closeButtonLabel') }}</Button>
		</Space>
	</Modal>
</template>

<script>
import { Button, Input, Modal, Space, TypographyParagraph, message } from 'ant-design-vue';
import { useI18n } from 'vue-i18n';


export default {
	components: {
		Button,
		Input,
		Modal,
		Space,
		TypographyParagraph,
	},
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		rawKey: {
			type: String,
			required: true,
		},
	},
	emits: ['close'],
	setup(props) {
		const { t } = useI18n();

		const copyRawKey = () => {
			const onCopySuccess = () => {
				message.success(t('account.externalApiKeys.createdModal.copySuccess'));
			};
			if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
				navigator.clipboard.writeText(props.rawKey).then(onCopySuccess).catch(() => {
					message.error(t('common.unknownError'));
				});
				return;
			}
			const textarea = document.createElement('textarea');
			textarea.value = props.rawKey;
			document.body.appendChild(textarea);
			textarea.select();
			try {
				if (document.execCommand('copy')) {
					onCopySuccess();
				} else {
					message.error(t('common.unknownError'));
				}
			} catch (err) {
				message.error(t('common.unknownError'));
			}
			document.body.removeChild(textarea);
		};

		return {
			copyRawKey,
		};
	},
};
</script>
